import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { ApiResponse } from '../../../../../common/api/response.types'
import { ProviderListQuery } from './query.types'
import {
  IProviderCreateBody,
  IProviderCredentialRuleCreateBody,
  IProviderCredentialRuleUpdateBody,
  IProviderCredentialRuleUpdateKeysBody,
} from './requests.types'
import {
  IProviderBase,
  IProviderCredentialRule,
  ISelectOption,
  IProviderSummary,
} from './types'

export const getProviderManagementSummary = () =>
  axios.get<ApiResponse<IProviderSummary>>(`${API_URL}/api/internal/payment-adapter/summary`)

export const getProviderList = (params: ProviderListQuery) =>
  axios.get<ApiResponse<IProviderBase[]>>(`${API_URL}/api/internal/payment-adapter`, { params })

export const getProviderBindings = (providerId: number) =>
  axios.get<ApiResponse<IProviderCredentialRule[]>>(
    `${API_URL}/api/internal/payment-adapter/${providerId}/binding`
  )

export const getMerchantLookup = () =>
  axios.get<ApiResponse<ISelectOption<number>[]>>(`${API_URL}/api/merchant/lookup`)

export const getPaymentMethodLookup = () =>
  axios.get<ApiResponse<ISelectOption<number>[]>>(`${API_URL}/api/payment-method/lookup`)

export const createProvider = (data: IProviderCreateBody) =>
  axios.post<ApiResponse<IProviderBase>>(`${API_URL}/api/internal/payment-adapter`, data)

export const toggleProviderEnabled = (providerId: number) =>
  axios.patch<ApiResponse<IProviderBase>>(
    `${API_URL}/api/internal/payment-adapter/${providerId}/toggle-enable`
  )

export const createCredentialRule = (providerId: number, data: IProviderCredentialRuleCreateBody) =>
  axios.post<ApiResponse<IProviderCredentialRule>>(
    `${API_URL}/api/internal/payment-adapter/${providerId}/binding`,
    data
  )

export const updateCredentialRule = (
  providerId: number,
  ruleId: number,
  data: IProviderCredentialRuleUpdateBody,
) =>
  axios.put<ApiResponse<IProviderCredentialRule>>(
    `${API_URL}/api/internal/payment-adapter/${providerId}/binding/${ruleId}`,
    data
  )

export const deleteCredentialRule = (providerId: number, ruleId: number) =>
  axios.delete<ApiResponse<null>>(
    `${API_URL}/api/internal/payment-adapter/${providerId}/binding/${ruleId}`
  )

export const updateCredentialRuleKeys = (
  providerId: number,
  ruleId: number,
  data: IProviderCredentialRuleUpdateKeysBody,
) =>
  axios.put<ApiResponse<IProviderCredentialRule>>(
    `${API_URL}/api/internal/payment-adapter/${providerId}/binding/${ruleId}/keys`,
    data
  )
